module.exports = __webpack_public_path__ + "img/live-edit.6d0bd2a5.svg";